export function objectToQueryString(obj) {
    const params = new URLSearchParams();
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        params.append(key, obj[key]);
      }
    }
    return params.toString();
}

export function formPhpFullUrl(url) {
  const phpBaseUrl = window.ENV?.phpBaseUrl || '';
  console.log("phpBaseUrl=" + phpBaseUrl);
  const phpFullUrl = `${phpBaseUrl}${url}`;
  console.log("phpFullUrl=" + phpFullUrl);
  return phpFullUrl;
}

  